import { getMLDrivenItems } from "../../../../fetch/graphql/requests/mlDrivenItems/library";
import {
    MLDRIVEN_ITEMS_PAGE_SIZE_BUFFER,
    MLDRIVEN_ITEMS_ALGORITHM_TYPE,
    MLDRIVEN_ITEMS_TYPE_VIDEO,
} from "./constants";
import { transformAllContentItems } from "../../../../utils/dataTransform/library";
import { transformForLayouts } from "../../../../utils/dataTransform/ContentQueryWidget/library";
import log from "../../../../utils/logger/library";

export const fetchMLDrivenItems = async (mlDrivenItemsQuery) => {
    const { args, pageSize, algorithm } = mlDrivenItemsQuery || {};
    const pageSizeNum = parseInt(pageSize);

    try {
        if (!args || !algorithm || Number.isNaN(pageSizeNum)) {
            throw new Error("fetchMLDrivenItems query params invalid");
        } else if (
            algorithm === MLDRIVEN_ITEMS_ALGORITHM_TYPE.RECOMMENDED &&
            !args.userId
        ) {
            throw new Error(
                "fetchMlDrivenItems query args require userId for recommended algorithm"
            );
        }

        /**
         * In order to ensure the correct amount of cards are rendered onto the screen, a page size buffer
         * is passed to the fetch function. The fetch function can sometimes return empty data which reduces the number of cards
         * shown on the page.
         */
        const result = await getMLDrivenItems(
            algorithm,
            args,
            pageSizeNum + MLDRIVEN_ITEMS_PAGE_SIZE_BUFFER,
            MLDRIVEN_ITEMS_TYPE_VIDEO
        );

        const cardContentItems = result?.data?.mlDrivenItems?.items?.slice(
            0,
            pageSizeNum
        );

        const transformedContentItems = cardContentItems?.length
            ? transformAllContentItems(cardContentItems)
            : [];

        return transformedContentItems;
    } catch (error) {
        log.error(`(fetchMLDrivenItems) failed: ${error}`);
    }

    return null;
};

export const fetchMLDrivenItemsForLayout = async (
    mlDrivenItemsConfig,
    path
) => {
    const { layout, query } = mlDrivenItemsConfig || {};
    const safePath = path || "/";

    try {
        if (!layout) {
            throw new Error("fetchMLDrivenItemsForLayout params invalid");
        }

        const contentItems = await fetchMLDrivenItems(query);

        const mlDrivenContentItems = contentItems?.length
            ? transformForLayouts(contentItems, layout, safePath)
            : [];

        return mlDrivenContentItems;
    } catch (error) {
        log.error(`(fetchMLDrivenItemsForLayout) failed`, error);
    }

    return null;
};
